jQuery(function() {
  // Readmore component
  const readmoreItems = $('[id*="bento-readmore"]');

  if (readmoreItems.length) {
    readmoreItems.each(function() {
      let readmoreItemClass,
          readmoreStateWording = $(this).data('collapsed') ? $(this).data('readmore-text') : $(this).data('readless-text')
      ;
      const readmoreItemHeight = $(this).height(),
            readmoreItemClasses = $(this).attr('class').split(/\s+/),
            readmoreItemState = $(this).data('collapsed') ? 'collapsed' : '',
            readmoreBtn = '<a class="readmore-btn ' + readmoreItemState + '">' + readmoreStateWording + '</a>'
      ;

      // Init component
      $(this).addClass('collapse')
        // Overrides Bootstrap Collapse height reset
        .css('min-height', readmoreItemHeight)
      ;

      // Get Readmore class
      $.each(readmoreItemClasses, function(i, name) {
        if (name.indexOf('bento-readmore-lines') > -1) {
          readmoreItemClass = name;
        }
      });

      // Readmore item default state
      if (readmoreItemState != 'collapsed') {
        $(this).toggleClass(readmoreItemClass)
          .collapse('show')
        ;
      }

      // Append the Readmore button to the Readmore item
      $(this).after(readmoreBtn);

      const $readmoreBtnSelector = $(this).next('.readmore-btn');

      $readmoreBtnSelector.attr({
        'role': 'button',
        'data-toggle': 'collapse',
        'href': '#' + $(this).attr('id'),
        'aria-expanded': $readmoreBtnSelector.hasClass('collapsed') ? 'false' : 'true',
        'aria-controls': $(this).attr('id')
      });

      // Readmore Bootstrap logic
      $(this).on('show.bs.collapse', function() {
        // Removes the line-clamp class for clean animations
        $(this).toggleClass(readmoreItemClass);

        readmoreStateWording = $(this).data('readless-text');
        $readmoreBtnSelector.text(readmoreStateWording);
      });

      $(this).on('hide.bs.collapse', function() {
        readmoreStateWording = $(this).data('readmore-text');
        $readmoreBtnSelector.text(readmoreStateWording);
      });

      $(this).on('hidden.bs.collapse', function() {
        $(this).toggleClass(readmoreItemClass);
      });
    });
  };
});
